import { onBeforeUnmount } from 'vue';
import {
  registerExclusiveVideoPlayer,
  claimExclusiveVideoPlayback,
} from '@/utils/exclusiveVideoPlayback';

export function useExclusiveVideoPlayback(playerId, { onForcePause, getVideoEl }) {
  const unregister = registerExclusiveVideoPlayer(playerId, {
    onForcePause,
    getVideoEl,
  });

  onBeforeUnmount(unregister);

  function claimPlayback(videoEl = null) {
    claimExclusiveVideoPlayback(playerId, videoEl ?? getVideoEl?.() ?? null);
  }

  return { claimPlayback };
}
